import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@isophi/core-legacy';

import { RouterLinkFactory } from '../router/router-link.factory';

@Injectable()
export class AuthGuard implements CanActivate {
  private prevState: RouterStateSnapshot | null = null;

  public constructor(private router: Router, private authService: AuthService, private links: RouterLinkFactory) {}

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.loggedUser) {
      this.router.navigate(this.links.login());
      this.prevState = state;
      return false;
    }

    if (
      this.authService.loggedUser.requirePhonelVerification &&
      !this.authService.loggedUser.isPhonelVerified &&
      state.url !== this.links.phoneVerification().join('/')
    ) {
      this.router.navigate(this.links.phoneVerification());
      this.prevState = state;
      return false;
    }

    this.prevState = state;
    return true;
  }

  private shouldAllowRoute(currentState: RouterStateSnapshot): boolean {
    if (this.prevState?.url !== currentState.url) {
      return false;
    }
    return true;
  }
}
